.button {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: var(--card-image-action-size, 32px);
  height: var(--card-image-action-size, 32px);
  padding: 0;
  border: 1px solid var(--colors-grays-ultralight);
  border-radius: 50%;
  background: var(--colors-grays-white);
  cursor: pointer;
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button:enabled:hover,
.button:enabled:focus-visible {
  background: var(--colors-grays-ultralight);
}
